"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import m from "../components/Icon/SvgIcon.js";
const t = (l) => /* @__PURE__ */ o(
  m,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.561 5.963H9.982v2.382H7.614v1.587h2.368v2.38h1.58v-2.38h2.367V8.345h-2.368zm8.423 14.734-4.492-6.139c1.557-1.31 2.55-3.251 2.55-5.42C18.041 5.203 14.78 2 10.771 2S3.5 5.203 3.5 9.137c0 3.938 3.263 7.14 7.271 7.14a7.3 7.3 0 0 0 3.106-.695l4.546 6.214c.154.211.444.268.646.126l.827-.583a.453.453 0 0 0 .088-.642m-9.213-6.125c-3.053 0-5.535-2.438-5.535-5.435 0-2.995 2.482-5.432 5.535-5.432 3.051 0 5.536 2.437 5.536 5.432 0 2.997-2.484 5.435-5.536 5.435",
        clipRule: "evenodd"
      }
    )
  }
), h = e(t);
export {
  h as ZoomIn,
  h as default
};
